import { useMemo } from "react";

import { getLatestReviewId } from "features/cdm/utils/getLatestReviewId";

import { usePatientCDMStatus } from "./usePatientCDMStatus";

// Resolves the patient's most recent programme review id from the status
// endpoint. Reuses the cached usePatientCDMStatus query, so it adds no extra
// request. Used to scope the care-plan endpoints when no specific review is
// being viewed (the "current/latest plan" case in KIN-1194).
export const useLatestReviewId = (patientId) => {
  const { data: cdmStatus } = usePatientCDMStatus(patientId);

  return useMemo(
    () => getLatestReviewId(cdmStatus?.reviewHistory),
    [cdmStatus?.reviewHistory]
  );
};
